module.exports = __webpack_public_path__ + "img/Promo_du_Jour2.e89c552f.png";